import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

import EcosystemLink from './components/EcosystemLink';

const Ecosystem = ({ data }) => (
  <div className={styles.ecosystem}>
    <div className={styles.ecosystem_bg}></div>
    <div className={classnames('cr-wrap', styles.ecosystem_inner)}>
      <div className={styles.ecosystem_inner_l}>
        <div className={styles.ecosystem_txt}>
          <h2 className={classnames('cr-h2', styles.ecosystem_txt_title)}>
            {data.title}
          </h2>
          <p className={classnames('cr-lead', styles.ecosystem_txt_desc)}>
            {data.desc}
          </p>

          <EcosystemLink data={data.btn} className={styles.ecosystem_txt_btn} />
        </div>
      </div>
      <div className={styles.ecosystem_inner_r}>
        <div className={styles.ecosystem_graphics}></div>

        <EcosystemLink
          data={data.btn}
          className={styles.ecosystem_inner_r_btn}
        />
      </div>
    </div>
  </div>
);

export default Ecosystem;
